import { render, staticRenderFns } from "./editorPopoverOptionButton.vue?vue&type=template&id=aed2724e&scoped=true&"
import script from "./editorPopoverOptionButton.vue?vue&type=script&lang=js&"
export * from "./editorPopoverOptionButton.vue?vue&type=script&lang=js&"
import style0 from "./editorPopoverOptionButton.vue?vue&type=style&index=0&id=aed2724e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed2724e",
  null
  
)

export default component.exports